import DatePicker, {
    DateObject,
    getAllDatesInRange,
} from "react-multi-date-picker";
var moment = require("jalali-moment");

export function FilterFn(row, columnId, filterValue, type = "string") {

    switch (type) {
        case "string":
            return row?.original?.[columnId]?.includes(filterValue)
        case "array":
            return row?.original[columnId].some(item => item?.includes(filterValue));
        case "object":
            if (filterValue == "all") {
                return true
            } else {
                return (row?.original?.[columnId])?.toString() == filterValue
            }
        case "date":
            let from, to;
            filterValue[0]
                ? (from = Date.parse(
                    new DateObject(
                        moment
                            .from(filterValue[0], "fa", "YYYY/MM/DD")
                            ?.format("YYYY/MM/DD")
                    )
                ))
                : (from = false);
            filterValue[1]
                ? (to = Date.parse(
                    new DateObject(
                        moment
                            .from(filterValue[1], "fa", "YYYY/MM/DD")
                            ?.format("YYYY/MM/DD")
                    )
                ))
                : (to = false);
            if (from && from > Date.parse(row.original[columnId])) {
                return false;
            }
            if (to && to < Date.parse(row.original[columnId])) {
                return false;
            }
            return true;
        default:
            break;
    }

}